/**
 * @generated SignedSource<<c7413d8d023e04f6cc90b5abcf284330>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly user: {
    readonly accountId: string;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer";
};
export type singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "singleSelectUserPickerField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v0/*: any*/)
      ]
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};
})();

(node as any).hash = "cbff593391c984a93de503c9ab16098d";

export default node;
